import {
  AUSTRALIA_NEWZEALAND_PAGE,
  WORKDAY_EN_PATH,
} from "../../../../interfaces/Static/routing_paths";
import casting_plant from "../../../../assets/images/oceania/casting_plant.webp";
import casting_plant_banner from "../../../../assets/images/oceania/casting_plant_banner.webp";
import { AUSTRALIA_NEWZEALAND_PROGRAM } from "./_programs";
const ANZ_LOCATIONS = {
  id: 1,
  name: "Australia",
  slug: "dandenong-victoria",
  items: AUSTRALIA_NEWZEALAND_PROGRAM.filter(
    (x) => ["dandenong-victoria"].indexOf(x.slug) >= 0
  ),
};
export const CASTING_PLANT = {
  id: "casting_plant",
  card_src: casting_plant,
  card_title: "page.oceania.casting_plant",
  card_description: "page.oceania.casting_plant_description",
  banner_src: casting_plant_banner,
  banner_title: "page.oceania.casting_plant",
  banner_description: "Australia's world leading manufacturing plant",
  slug: "casting-plant",
  href: `${AUSTRALIA_NEWZEALAND_PAGE}/casting-plant`,
  name: "page.oceania.casting_plant",
  description:
    "At Nissan Casting Australia, every High Pressure Die Casting we produce is a testament to Australian ingenuity, fuelling innovation in Nissan vehicles around the world. Each part we produce carries the Kangaroo stamp, a mark of Australian engineering excellence and a symbol of the pride our team takes in every casting. This emblem isn't just decorative, it reflects the passion and precision that goes into creating parts for 12 Nissan manufacturing plants worldwide. <br /><br /> As the only ongoing automotive manufacturer in Australia, we are at the forefront of casting innovation, particularly in components for electric vehicles. Our facility has received global recognition for its advanced engineering and commitment to quality. <br /><br /> From engineering and procurement to project management, the opportunities at Nissan Casting Australia are dynamic and ongoing. And for those with a global mindset, it’s a launch-pad to a career in advanced manufacturing across the Nissan Alliance.",
  categories: [
    {
      id: 1,
      name: "Manufacturing Excellence",
      slug: "manufacturing_excellence",
      description:
        "The casting plant has operated for 40 years adapting and growing with every new generation of technology. Our Casting plant is recognised for its world leading engineering solutions and quality. We take great pride in every part manufactured at our South Dandenong Casting Plant.  Our focus on continuous improvement of manufacturing processes and systems to increase safety and improve quality has delivered Global awards and recognition.",
      locations: [ANZ_LOCATIONS],
    },
    {
      id: 2,
      name: "Starting Out",
      slug: "starting_out",
      description:
        "You may be looking for an Engineering Internship or ready to take the first step after graduation. At Nissan Casting Plant, you’ll join a team with a proud history of shaping talent and producing world-class innovation. Our plant is more than just a workplace, it’s an engine bay where curiosity is sparked, skills are tuned, and careers accelerate. <br /><br /> Here, you’ll work alongside experienced engineers and technicians, gaining hands-on exposure to advanced High Pressure Die Casting (HPDC) processes and cutting-edge manufacturing techniques. With mentoring, structured training, and real project involvement, you’ll grow the practical knowledge and confidence to make an impact from day one. <br /><br /> Many of our interns and graduates have gone on to build long and rewarding careers with Nissan, both in Australia and around the globe. The Kangaroo stamp proudly featured on our parts is a symbol of the pride we carry in being Australia’s only ongoing, leading-edge automotive casting facility, and you can be part of that story.",
      locations: [ANZ_LOCATIONS],
    },
    {
      id: 3,
      name: "Specialist Areas",
      slug: "specialist_areas",
      description:
        "We have numerous opportunities for experienced Manufacturing / Process Engineers, Maintenance / Automation Engineers, Quality Engineers, Design Engineers, Tooling Engineers and Safety Engineer.",
      locations: [ANZ_LOCATIONS],
    },
    {
      id: 4,
      name: "Career pathways",
      slug: "career_pathways",
      description:
        "As part of Nissan's Global Manufacturing (Monozukuri) Function there are many opportunities to engage with colleagues from around the world and be part of leading edge projects and development.",
      locations: [ANZ_LOCATIONS],
    },
  ],
  work_day_link: `https://www.livehire.com/careers/nissan/jobs`,
};
